// extracted by mini-css-extract-plugin
export default {"loadingButton":"AddPartnerButton_loadingButton__41XTk","loader":"AddPartnerButton_loader__QXTTB"};